export const agreementState = {
  hasSign: {
    status: 1
  },
  stopSign: {
    status: 2
  },
  unSign: {
    status: 3
  }
};

export const houseTypeState = {
  centered: {
    status: 0
  },
  scattered: {
    status: 1
  }
};

export const permissionTypeState = {
  unReq: 0,
  hasPermission: 1,
  noPermission: 2
};

export const manageStatusOptions = [
  {
    value: 1,
    text: "待出租"
  },
  {
    value: 3,
    text: "配置中"
  }
];

export const onoffStatusOptions = [
  {
    value: 0,
    text: "未上架"
  },
  {
    value: 2,
    text: "已上架"
  }
];

export const houseTypeOptions = [
  {
    value: houseTypeState.scattered.status,
    text: "分散式"
  },
  {
    value: houseTypeState.centered.status,
    text: "集中式"
  }
];
